import React from 'react';
import PropTypes from 'prop-types';

const DefaultEntityLayout = ({
  pillBar,
  eventsPanel,
  eventSEOList,
  noEventsPanel,
  sideSection,
  entitySEOLinks,
  nearbyVenues,
  venuePerformers,
  venueSEOList,
  spotifyArtistId,
}) => (
  <div className="EntityPage__content" data-spotify-artist-id={spotifyArtistId}>
    <section className="EntityPage__main">
      {pillBar}
      {eventsPanel}
      {eventSEOList}
      {noEventsPanel}
      {entitySEOLinks && entitySEOLinks}
      {nearbyVenues}
      {venuePerformers}
      {venueSEOList}
    </section>
    <aside className="EntityPage__aside">{sideSection}</aside>
  </div>
);

DefaultEntityLayout.propTypes = {
  pillBar: PropTypes.object.isRequired,

  /**
   * Events Panel Section
   */
  eventsPanel: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  eventSEOList: PropTypes.object,
  noEventsPanel: PropTypes.object,
  sideSection: PropTypes.object.isRequired,

  /**
   * Events SEO mark up section
   */
  entitySEOLinks: PropTypes.object,

  /**
   * Nearby Venues section - SEO Internal Linking
   */
  nearbyVenues: PropTypes.array,

  /**
   * Venue Performers section - SEO Internal Linking
   */
  venuePerformers: PropTypes.array,

  /**
   * Performer & grouping venue SEO Links
   */
  venueSEOList: PropTypes.node,

  /**
   * Spotify Artist ID
   */
  spotifyArtistId: PropTypes.string,
};

export default DefaultEntityLayout;
